export default __webpack_public_path__ + "static/media/exploded-view_labels.8bb5a598.png";